import { IconProps } from './icons-props';

function PlayIcon({ className, width = 8, height = 9 }: IconProps) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 8 9'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M2.23002 8.47712C1.89145 8.47712 1.57001 8.39569 1.28715 8.23283C0.618575 7.84712 0.25 7.06282 0.25 6.02996V2.97421C0.25 1.93706 0.618575 1.15705 1.28715 0.77133C1.95573 0.385612 2.81717 0.45847 3.71718 0.977047L6.36149 2.50278C7.25721 3.02135 7.75436 3.73279 7.75436 4.50423C7.75436 5.27566 7.2615 5.9871 6.36149 6.50567L3.71718 8.0314C3.1986 8.32712 2.69288 8.47712 2.23002 8.47712Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default PlayIcon;

